import { render, staticRenderFns } from "./Wait.vue?vue&type=template&id=2adc3b23&scoped=true"
import script from "./Wait.vue?vue&type=script&lang=ts"
export * from "./Wait.vue?vue&type=script&lang=ts"
import style0 from "./Wait.vue?vue&type=style&index=0&id=2adc3b23&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adc3b23",
  null
  
)

export default component.exports